$(function () {
    // TRACKS
    var selectedTracks = [];
    var trackButtons = $('.track-button');
    var clearTracksButton = $('#clear-tracks-button');
    trackButtons.click(function () {
        var trackButton = $(this);
        var track = trackButton.data('track');

        if (isTrackSelected(track.id)) {
            deselectTrack(trackButton);
        } else {
            selectTrack(trackButton);
        }
    });

    clearTracksButton.click(function () {
        trackButtons.each(function (index, trackButton) {
            deselectTrack($(trackButton));
        });
    });

    function isTrackSelected(trackId) {
        return selectedTracks.indexOf(trackId) > -1;
    }

    function selectTrack(trackButton) {
        var track = trackButton.data('track');
        selectedTracks.push(track.id);
        trackButton.addClass('track-active');
        trackButton.css('background-color', track.color);
        clearTracksButton.show();
        filterSessionsByTags();
    }

    function deselectTrack(trackButton) {
        var trackId = trackButton.data('track').id;
        var index = selectedTracks.indexOf(trackId);
        if (index > -1) {
            selectedTracks.splice(index, 1);
        }
        trackButton.removeClass('track-active');
        trackButton.css('background-color', '');
        if (selectedTracks.length === 0) {
            clearTracksButton.hide();
        }
        filterSessionsByTags();
    }

    function filterSessionsByTags() {
        $('[data-tracks]').each(function () {
            const sessionElem = $(this);
            const tracks = sessionElem.data('tracks');
            sessionElem.removeClass('filtered');
            if (selectedTracks.length > 0 &&
                _.intersection(tracks, selectedTracks).length === 0) {
                sessionElem.addClass('filtered');
            }
        })
    }

    // DATE PICKER
    var scheduleDateDropdownButton = $('#schedule-date-dropdown');
    var scheduleDateDropdownMenu = $('#schedule-date-dropdown-menu');

    var selectedDay;
    var days = data.days.map(function (day) {
        return moment(day, 'YYYY-MM-DD');
    });
    if (days.length > 0) {
        selectDate(days[0]);
    }

    function getDateDropdownItem(date) {
        var dropdownItem = $(document.createElement('a'));
        dropdownItem.addClass('dropdown-item cursor-pointer');
        if (date.isSame(selectedDay, 'day')) {
            dropdownItem.addClass('text-active');
        }
        dropdownItem.attr('data-day', date.clone().locale('en').format('YYYY-MM-DD'));
        dropdownItem.text(date.format('dddd DD MMM'));
        dropdownItem.click(function () {
            return selectDate(moment($(this).data('day'), 'YYYY-MM-DD'), true);
        })
        return dropdownItem;
    }

    function generateDateDropdown() {
        scheduleDateDropdownMenu.empty();
        days.forEach(function (day) {
            scheduleDateDropdownMenu.append(getDateDropdownItem(day));
        });
    }

    function selectDate(day, download = false) {
        const enDay = day.clone().locale('en');
        if (download) {
            getSchedule(enDay);
        }
        scheduleDateDropdownButton.text(day.format('dddd'));
        selectedDay = enDay;
        generateDateDropdown();
    }

    // SCHEDULE
    var scheduleData = $('#schedule-data');
    var startScrollPosition, currentPage = 0;
    var hallCount = 0;

    function getSchedule(day) {
        $.get(window.getLocation('schedule'), {
            date: day.format('YYYY-MM-DD')
        }, function (data) {
            scheduleData.empty();
            scheduleData.append(data);
            init();
        })
    }

    function computeHallCount() {
        hallCount = 0;
        $('[data-max-overlap-index]').each(function () {
            const hallElem = $(this);
            hallCount += +hallElem.data('max-overlap-index');
        });
    }

    function init() {
        if ($('.hall').length === 0) return;

        computeHallCount();
        setBreakpoints(window.innerWidth);
        checkButtonsVisibility();
        filterSessionsByTags();

        $('.halls').on('scrollend', function () {
            checkButtonsState($(this).scrollLeft());
        });

        $('#prev-hall').click(function () {
            moveSchedule(-1);
        });

        $('#next-hall').click(function () {
            moveSchedule(1);
        });
    }

    init();

    $(window).resize(function () {
        setBreakpoints(window.innerWidth);
        checkButtonsVisibility();
    });

    /**
     * set --halls-per-view css variable, based on width and halls parameter
     * @param width
     * @private
     */
    function setBreakpoints(width) {
        let hallsPerView = 0;

        if (width <= 650) {
            hallsPerView = 1;
        } else if (width <= 850) {
            hallsPerView = 2;
        } else if (width <= 1200) {
            hallsPerView = 3
        } else if (width <= 1600) {
            hallsPerView = 4
        } else if (width <= 1900) {
            hallsPerView = 5
        } else if (width <= 2500) {
            hallsPerView = 6
        } else {
            hallsPerView = 7;
        }

        if (hallCount > hallsPerView) {
            hallsPerView += 0.2;
        } else {
            hallsPerView = hallCount;
        }

        document.documentElement.style.setProperty('--halls-per-view', hallsPerView.toString());
    }

    /**
     * Check if buttons for halls paging should be visible
     * @private
     */
    function checkButtonsVisibility() {
        const hallsPerView = +getComputedStyle(document.documentElement).getPropertyValue('--halls-per-view');
        const visible = hallCount > hallsPerView;

        $('#prev-hall').toggle(visible);
        $('#next-hall').toggle(visible);
    }

    function moveSchedule(number) {
        const halls = $('.halls').get(0);

        const scheduleWidth = halls.getBoundingClientRect().width;
        const hallsPerView = +getComputedStyle(document.documentElement).getPropertyValue('--halls-per-view');
        const hallWidth = scheduleWidth / hallsPerView;
        currentPage += number;

        // hallWidth * 0.2 is because we always show a little peak of next hall, thus 0.2
        const left = (scheduleWidth - hallWidth * 0.2) * currentPage;
        halls.scrollTo({
            left,
            behavior: 'smooth'
        });
        startScrollPosition = left;
    }

    /**
     * Check which buttons should be disabled, based on scrollLeft position
     * @param left
     * @private
     */
    function checkButtonsState(left) {
        const halls = $('.halls').get(0);
        const maxScrollLeft = halls.scrollWidth - halls.getBoundingClientRect().width;
        $('#prev-hall').prop( 'disabled', +left <= 0);
        $('#next-hall').prop( 'disabled', maxScrollLeft <= left);
    }
});
